import React from "react";
import styled from "styled-components";
import { ModalBody } from "./Modal";
import { closeModal, openModal } from "../../redux/ModalSlice";
import { useDispatch } from "react-redux";
import mallManager from "../../apis/mallManager";
import { MODAL_PAYLOAD } from "../../constants";

const PolicyAgreementModal = () => {
    const dispatch = useDispatch();
    const [checked, setChecked] = React.useState(false);

    const openNoticeModal = async () => {
        setChecked(true);
        const requestData = {is_agree: true};
        await mallManager.updateMallInfo(requestData);
        dispatch(closeModal());
        dispatch(openModal({ ...MODAL_PAYLOAD.NOTICE_DETAIL }));
        // noticeManager
        //     .readConfirm({
        //         id: 4,
        //     })
        //     .then();
        // window.location.href=`/notice-detail/4`;
    }

    return (
        <ModalBody>
            <ModalContainer>
                <ModalText>
                    <TextNo>1</TextNo>
                    업데이트 이후 스크립트 설치를 통해서만 스크립트 추가가 가능하며,<br/>
                    해당 기능을 통해 생성된 스크립트를 임의로 옮기지 않는 것에 동의합니다.
                </ModalText>
                <ModalText>
                    <TextNo>2</TextNo>
                    업데이트 이후 반드시 기존 스크립트를 제거하고 스크립트 설치 진행을 하여야<br/>
                    정상적인 배너 노출이 됨을 인지하였습니다
                </ModalText>
                <ModalText>
                    <TextNo>3</TextNo>
                    업데이트 이후 각 배너별 태그를 설치된 스크립트가 설치된 위치보다<br />
                    상단에 삽입하였을 경우 해당 배너가 노출되지 않을 수 있음을 인지하였습니다.
                </ModalText>
                <ModalText>
                    <TextNo>4</TextNo>
                    해당 앱 정책에 동의를 진행하지 않을 시 앱 사용이 제한 될 수 있음을 인지하였습니다.
                </ModalText>
                <LinkText>
                    <input
                        type={"checkbox"}
                        checked={checked}
                        onClick={openNoticeModal}
                    />
                    위 사항을 모두 확인하였으며 이에 동의합니다.
                </LinkText>
            </ModalContainer>
        </ModalBody>
    );
};

const ModalContainer = styled.div`
    background-color: #F9F9FA;
    padding: 20px 20px 5px 20px;
    border-radius: 5px;
`;

const ModalText = styled.p`
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: #282B39;
    align-items: center;
`;

const TextNo = styled.span`
    display: block;
    width: 25px;
    height: 25px;
    border: 1px solid #7386E8;
    border-radius: 5px;
    background-color: #7386E8;
    color: #FFFFFF;
    text-align: center;
    margin-right: 10px;
`;

const LinkText = styled.div`
    display: flex;
    margin-top: 30px;
    justify-content: right;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: #282B39;
    align-items: center;
    text-decoration: underline;
    
    input {
        cursor: pointer;
    }
`;

export default PolicyAgreementModal;
